import React from 'react';
import EasyLoading from "../../../components/easy-loading";
import {EL_MODE_CREATE} from "../../../components/easy-loading/constants";

const EasyLoadingCreate = () =>
  <EasyLoading
    mode={EL_MODE_CREATE}
  />;

export default EasyLoadingCreate;


// WEBPACK FOOTER //
// ./src/scenes/easy-loading/easy-loading-create/index.jsx